export class ResetPasswordModel {
  public OldPassword: string;
  public NewPassword: string;
  public ConfirmNewPassword: string;
  public Token: string;
  public UserId: string;
  public Page: string;

  constructor(userId: string, token: string, page: string) {
    this.Token = token;
    this.UserId = userId;
    this.Page = page;
  } 
}
